import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, aspect = "aspect-[4/3]" }) => {
  const [val, setVal] = useState(50);

  return (
    <div data-testid="before-after-slider" className={`relative w-full ${aspect} overflow-hidden bg-navy select-none`}>
      {/* After (base) */}
      <img src={after} alt="After painting" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
      {/* Before (clipped) */}
      <img
        src={before}
        alt="Before painting"
        draggable={false}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - val}% 0 0)` }}
      />

      <span className="absolute top-4 left-4 font-primary uppercase text-xs tracking-widest bg-navy/80 text-ice px-3 py-1.5 z-20" style={{ opacity: val > 12 ? 1 : 0 }}>
        Before
      </span>
      <span className="absolute top-4 right-4 font-primary uppercase text-xs tracking-widest bg-gold text-navy px-3 py-1.5 z-20" style={{ opacity: val < 88 ? 1 : 0 }}>
        After
      </span>

      {/* Divider line + handle */}
      <div className="absolute top-0 bottom-0 z-20 pointer-events-none" style={{ left: `${val}%` }}>
        <div className="absolute top-0 bottom-0 -translate-x-1/2 w-1 bg-gold" />
        <div className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-gold flex items-center justify-center shadow-[3px_3px_0px_#0B2545]">
          <MoveHorizontal size={22} className="text-navy" />
        </div>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        value={val}
        onChange={(e) => setVal(Number(e.target.value))}
        data-testid="before-after-range"
        aria-label="Drag to compare before and after"
        className="ba-range absolute inset-0 z-30 h-full w-full opacity-0"
        style={{ opacity: 0 }}
      />
    </div>
  );
};
